// extracted by mini-css-extract-plugin
export const card = "projects-module--card--2LFz6";
export const date = "projects-module--date--12x_Z";
export const tag = "projects-module--tag--1GmXS";
export const icon = "projects-module--icon--2Z6Pg";
export const desc = "projects-module--desc--2YX-q";
export const containerImage = "projects-module--container-image--w4J5Y";
export const image = "projects-module--image--1Md3h";
export const cardsOuter = "projects-module--cards-outer--31LHx";